exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.error-page{position:relative;height:100vh;width:100vw;display:flex}.error-page__header{position:absolute;left:72px;top:64px;font-family:Open Sans,sans-serif;font-style:italic;font-weight:600;font-size:48px;color:#d8d8d8;line-height:64px}.error-page__logo{margin-top:220px;height:calc(100% - 220px)}.error-page__details{margin-top:220px;margin-left:100px;display:flex;flex-direction:column}.error-page__details .title{max-width:calc(100% - 80px);margin:0;font-family:Oswald,sans-serif;color:#2c2c2c;line-height:60px;font-size:40px;font-weight:500;text-transform:uppercase}.error-page__details .message{margin:40px 80px 0 0;min-width:300px;max-width:calc(100% - 80px);font-family:Open Sans,sans-serif;font-size:32px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ErrorPage/ErrorPage.scss
// module id = 1736
// module chunks = 0